<template>
  <div>
    <!-- 24-06-19 产品通知 因为合同管理第三方问题，功能隐藏 -->
    <!-- <ul class="examination_ul">
      <li class="tool_list" @click="fileContrastFn">
        <img
          class="img_size"
          src="../../static/images/AISmart/icon/duibi.png"
          alt=""
        />
        <div>智能文档比对</div>
      </li>
      <li class="tool_list" @click="contractWordFn">
        <img
          class="img_size"
          src="../../static/images/AISmart/icon/tiqu.png"
          alt=""
        />
        <div>合同关键词抽取</div>
      </li>
      <li class="tool_list" @click="riskExtractFn">
        <img
          class="img_size"
          src="../../static/images/AISmart/icon/wssc.png"
          alt=""
        />
        <div>法律风险审查</div>
      </li>
    </ul> -->
    <!-- 上传文件   -->
    <el-dialog
      title="上传文件"
      :visible.sync="uploadFileVisible"
      width="50%"
      append-to-body
    >
      <ul class="upload_file_ul">
        <li class="upload_file_li">
          <h4>原始文档</h4>
          <div class="upload_sign">
            <div v-if="fileList.originFile">
              <img
                :src="fileTypeFn(fileList.originFile)"
                class="file_type_img"
                alt=""
              />
              <div>{{ fileList.originFile.name }}</div>
            </div>
            <template v-else>
              <div class="upload_icon_box">
                <i class="el-icon-upload icon_size"></i>
              </div>
              <div class="el-upload__text">
                <p><em>点击上传</em> 或拖拽文件上传</p>
                <div class="tip_color">
                  支持doc、docx、pdf、xls、xlsx、.pptx、.ppt、.txt格式
                </div>
              </div>
            </template>
            <input
              class="input"
              type="file"
              accept=".doc,.docx,.pdf,.xls,.xlsx,.pptx,.ppt,.txt"
              @change="originFileChangeFn"
            />
          </div>
        </li>
        <li class="upload_file_li">
          <h4>对比文档</h4>
          <div class="upload_sign">
            <div v-if="fileList.targetFile">
              <img
                :src="fileTypeFn(fileList.targetFile)"
                class="file_type_img"
                alt=""
              />
              <div>{{ fileList.targetFile.name }}</div>
            </div>
            <template v-else>
              <div class="upload_icon_box">
                <i class="el-icon-upload icon_size"></i>
              </div>
              <div class="el-upload__text">
                <p><em>点击上传</em> 或拖拽文件上传</p>
                <div class="tip_color">
                  支持doc、docx、pdf、xls、xlsx、.pptx、.ppt、.txt格式
                </div>
              </div>
            </template>
            <input
              class="input"
              type="file"
              accept=".doc,.docx,.pdf,.xls,.xlsx,.pptx,.ppt,.txt"
              @change="targetFileChangeFn"
            />
          </div>
        </li>
      </ul>
      <div>
        对比规则设置：
        <el-checkbox
          v-model="ignorePunctuations"
          label="忽略标点符号"
        ></el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadFileVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="contractComparisonFn"
          :loading="comparisonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--   选择合同类型 -->
    <el-dialog :visible.sync="contractTypeVisible" width="30%" append-to-body>
      <div>
        <el-form
          :model="contractTypeForm"
          :rules="rules"
          ref="contractTypeForm"
          class="demo-contractTypeForm"
        >
          <el-form-item label="选择合同类型：" prop="region">
            <el-select
              v-model="contractTypeForm.region"
              placeholder="请选择合同类型"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in templateContractTypeList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contractTypeVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button @click="contractTypeSubmit" type="primary" size="mini">
          确认
        </el-button>
      </div>
    </el-dialog>
    <!-- 法律风险审查弹窗   -->
    <el-dialog
      :visible.sync="riskExaminationVisible"
      width="35%"
      append-to-body
    >
      <div>
        <el-form
          :model="riskForm"
          :rules="riskRules"
          ref="riskForm"
          class="demo-contractTypeForm"
        >
          <el-form-item label="合同领域：" prop="categoryId">
            <el-select
              v-model="riskForm.categoryId"
              placeholder="请选择合同领域"
              @change="categoryValChange"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in categoryList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核规则：" prop="ruleId">
            <el-select
              v-model="riskForm.ruleId"
              placeholder="请选择审核规则"
              :disabled="!riskForm.categoryId"
            >
              <el-option
                :label="Object.keys(item)[0]"
                :value="Object.values(item)[0]"
                v-for="(item, index) in examinationRuleList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件上传：" prop="targetStoreId">
            <div class="upload_sign">
              <div v-if="riskForm.targetStoreId">
                <img
                  :src="fileTypeFn({ name: riskForm.targetStoreId })"
                  class="file_type_img"
                  alt=""
                />
                <div>{{ riskForm.name }}</div>
              </div>
              <template v-else>
                <div class="upload_icon_box">
                  <i class="el-icon-upload icon_size"></i>
                </div>
                <div class="el-upload__text">
                  <p><em>点击上传</em> 或拖拽文件上传</p>
                  <div class="tip_color">支持doc、docx格式</div>
                </div>
              </template>
              <input
                class="input"
                type="file"
                accept=".doc,.docx"
                @change="riskFileChangeFn"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="riskExaminationVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button
          :loading="riskLoading"
          @click="riskExtractSubmitFn"
          type="primary"
          size="mini"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { uploadFileAndConvertInfoTwo } from "@/assets/js/http-serve/http-methods";
import GlobalConfig from "@/assets/js/config/global";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  name: "examination-tool",
  props: {
    defaultTargetFile: {
      type: [Object, String, null],
      required: false
    },
    checkAct: {
      type: Number | null,
      default: null,
      required: false
    }
  },
  data () {
    return {
      //href参数
      hrefParam: {},
      //=============比对
      uploadFileVisible: false,
      ignorePunctuations: false, //是否忽略标点
      defaultTargetFileData: "", //默认初始文件
      fileList: {
        //文件data
        originFile: "",
        targetFile: ""
      },
      fileIdList: {
        //文件id，特殊情况
        originStoreId: "",
        originFileType: "",
        targetStoreId: "",
        targetFileType: ""
      },
      comparisonLoading: false,
      //关键词合同类型列表==========
      contractTypeVisible: false,
      templateContractTypeList: [],
      contractTypeForm: {},
      rules: {
        region: [{ required: true, message: "请选择合同类型", trigger: "blur" }]
      },
      //风险审查=============
      riskExaminationVisible: false,
      riskLoading: false,
      categoryList: [], //审核类型
      examinationRuleList: [], //审核规则
      riskForm: {
        category: "",
        categoryId: "",
        rule: "",
        ruleId: "",
        targetStoreId: "",
        fileType: ""
      },
      riskRules: {
        categoryId: [
          { required: true, message: "请选择合同领域", trigger: "blur" }
        ],
        ruleId: [
          { required: true, message: "请选择审核规则", trigger: "blur" }
        ],
        targetStoreId: [
          { required: true, message: "请选择文件", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    defaultTargetFile:{
      handler(val){
        this.defaultTargetFileData = val;
        this.$nextTick(()=>{
          this.defaultValueFn(); //设置默认值
          if (val.createType != 0) {
            // API发起的合同属于免登。当不是API发起时就不用这两接口
            this.getContractCategoryList(); //风险审查类型列表
            this.getContractExtractListFn(); //合同关键词列表
          }
        })
      },
      deep:true,
      immediate:true
      
    },
    checkAct (val) {
      this.arrDefaultFile(this.defaultTargetFileData, "target", true); //设置默认值
    }
  },
  mounted () {
    this.hrefParam = this.$route.query;
  },
  methods: {
    //初始默认值调用方法
    defaultValueFn () {
      if (this.checkAct === null) {
        this.defaultFile(this.defaultTargetFileData, "target", true);
      } else {
        this.arrDefaultFile(this.defaultTargetFileData, "target", true);
      }
    },
    //审核类型
    getContractCategoryList () {
      ApiCorpMethods.ContractOpreationController.contractCategoryList().then(
        res => {
          this.categoryList = res.data;
        }
      );
    },
    //审核类型切换111
    categoryValChange () {
      ApiCorpMethods.ContractOpreationController.examinationRuleList({
        categoryId: this.riskForm.categoryId
      }).then(res => {
        this.examinationRuleList = res.data;
        this.riskForm.ruleId = "";
      });
    },
    //默认展示
    defaultFile (file, whichFile, first = false) {
      console.log('file',file);
      if (!file) return false;
      const info = file.fileInfo,infos=file.fileInfos;
      const new_info = infos && infos.length ? infos[0] : info
      // 此处发现 fileInfo 字段不一定存在，对应的是 fileInfos；不确定 fileInfo 字段是否一定存在
      this.fileIdList[`${whichFile}StoreId`] = new_info.targetId;
      this.fileIdList[`${whichFile}FileType`] = new_info.fileType;
      if (whichFile === "target" && first) {
        this.fileList[`${whichFile}File`] = {
          name: file.contractName,
          customType: new_info.targetId
        };
      }
    },
    //数组结构的默认展示
    arrDefaultFile (file, whichFile, first = false) {
      if (!file || isInDingTalk) return false;
      this.fileIdList[`${whichFile}StoreId`] =
        file.fileInfos[this.checkAct].targetId;
      this.fileIdList[`${whichFile}FileType`] =
        file.fileInfos[this.checkAct].fileType;
      if (whichFile === "target" && first) {
        this.fileList[`${whichFile}File`] = {
          // name: file.contractName,
          name: file.fileInfos[this.checkAct].fileName
            ? file.fileInfos[this.checkAct].fileName
            : file.contractName,
          customType: file.fileInfos[this.checkAct].targetId
        };
      }
    },
    //文件对比弹窗
    fileContrastFn () {
      this.uploadFileVisible = true;
    },
    //文件类型
    fileTypeFn (file) {
      // .doc,.docx,.pdf,.xls,.xlsx,.pptx,.ppt,.txt
      let types;
      if (file.customType) {
        types = file.customType.slice(file.customType.lastIndexOf(".") + 1);
      } else {
        types = file.name.slice(file.name.lastIndexOf(".") + 1);
      }
      switch (types) {
        case "doc":
        case "docx":
          return require("../../static/images/AISmart/file_type_w.png");
        case "pdf":
          return require("../../static/images/AISmart/file_type_p.png");
        case "xls":
        case "xlsx":
          return require("../../static/images/AISmart/file_type_x.png");
        case "ppt":
        case "pptx":
          return require("../../static/images/AISmart/file_type_ppt.png");
        case "txt":
          return require("../../static/images/AISmart/file_type_t.png");
        default:
          return require("../../static/images/AISmart/file_type_w.png");
      }
    },
    //文件变化-左
    originFileChangeFn: function (e) {
      if (e.target.files.length) {
        const re = new RegExp(
          "(.doc|.docx|.pdf|.xls|.xlsx|.pptx|.ppt|.txt)$",
          "i"
        ),
          isLt30M = e.target.files[0].size / 1024 / 1024 < 30;
        if (!isLt30M) return this.$message.error("上传文件大小不能超过 30MB!");
        if (!re.test(e.target.files[0].name)) {
          return this.$message.error(
            "文件格式只能是 doc / docx / pdf / xls / xlsx / pptx / ppt / txt文件"
          );
        }
        this.fileList.originFile = e.target.files[0];
        this.comparisonLoading = true;
        uploadFileAndConvertInfoTwo({
          file: e.target.files[0],
          fileName: e.target.files[0].name
        })
          .then(res => {
            this.comparisonLoading = false;
            this.defaultFile({ fileInfo: res }, "origin"); //适配target文件的参数格式
          })
          .catch(err => {
            this.comparisonLoading = false;
            this.$message.error(err.description);
          });
      }
    },
    //右
    targetFileChangeFn: function (e) {
      if (e.target.files.length) {
        const re = new RegExp(
          "(.doc|.docx|.pdf|.xls|.xlsx|.pptx|.ppt|.txt)$",
          "i"
        ),
          isLt30M = e.target.files[0].size / 1024 / 1024 < 30;
        if (!isLt30M) return this.$message.error("上传文件大小不能超过 30MB!");
        if (!re.test(e.target.files[0].name)) {
          return this.$message.error(
            "文件格式只能是 doc / docx / pdf / xls / xlsx / pptx / ppt / txt文件"
          );
        }
        this.fileList.targetFile = e.target.files[0];
        this.comparisonLoading = true;
        uploadFileAndConvertInfoTwo({
          file: e.target.files[0],
          fileName: e.target.files[0].name
        })
          .then(res => {
            this.comparisonLoading = false;
            this.defaultFile({ fileInfo: res }, "target"); //适配target文件的参数格式
          })
          .catch(err => {
            this.comparisonLoading = false;
            this.$message.error(err.description);
          });
      }
    },
    //审核文件上传
    riskFileChangeFn: function (e) {
      if (e.target.files.length) {
        const re = new RegExp("(.doc|.docx)$", "i"),
          isLt30M = e.target.files[0].size / 1024 / 1024 < 30;
        if (!isLt30M) return this.$message.error("上传文件大小不能超过 30MB!");
        if (!re.test(e.target.files[0].name)) {
          return this.$message.error("文件格式只能是 doc / docx 文件");
        }
        this.riskLoading = true;
        uploadFileAndConvertInfoTwo({
          file: e.target.files[0],
          fileName: e.target.files[0].name
        })
          .then(res => {
            this.riskLoading = false;
            this.riskForm.targetStoreId = res.targetId;
            this.riskForm.fileType = res.fileType;
            this.riskForm.name = e.target.files[0].name;
            this.riskForm.customType = res.targetId;
          })
          .catch(err => {
            this.riskLoading = false;
            this.$message.error(err.description);
          });
      }
    },
    closeFileViseble () {
      this.fileList = {
        //先清空文件
        originFile: "",
        targetFile: ""
      };
      this.fileIdList = {
        originStoreId: "",
        originFileType: "",
        targetStoreId: "",
        targetFileType: ""
      };
      this.defaultValueFn(); //设置默认值
      this.uploadFileVisible = false;
      this.ignorePunctuations = false; //标段符号checkbox
    },
    //文件比对提交
    contractComparisonFn () {
      this.comparisonLoading = true;
      let params = {
        ...this.fileIdList,
        ignorePunctuations: this.ignorePunctuations ? "1" : "0"
      };
      //手动传标识参数
      if (this.hrefParam.aiCorpUserIdFlag) {
        params.aiCorpUserIdFlag = this.hrefParam.aiCorpUserIdFlag;
      }
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      ApiCorpMethods.ContractOpreationController.contractComparisonStore(
        formData
      ).then(res => {
        this.submitResultHandle(res);
      });
    },
    //文件比对提交结果处理
    submitResultHandle (res) {
      this.comparisonLoading = false; //关闭loading
      if (res.success) {
        this.closeFileViseble();
        let routeUrl = this.$router.resolve({
          path: "/smartDoc/docContrast/contrastList"
        });
        isInDingTalk ? location.href = routeUrl.href : window.open(routeUrl.href, "_blank");
      } else if (res.code === "10807") {
        //套餐不足
        this.frequencyInsufficient("比对");
      } else {
        this.$message.error(res.description);
      }
    },
    //次数不足提示
    frequencyInsufficient (txt) {
      this.$alert(`当前无文档${txt}功能使用次数，请前往购买`, "提示", {
        confirmButtonText: "前往购买",
        cancelButtonText: "取消",
        callback: action => {
          const path = GlobalConfig.domain.accountWeb + "/asset/aiContractChargePage"
          isInDingTalk ?
            location.href = path :
            window.open(path);
        }
      });
    },
    //关键词抽取弹窗====================
    //获取合同类型抽取列表
    getContractExtractListFn () {
      ApiCorpMethods.ContractOpreationController.contractExtractList().then(
        res => {
          this.templateContractTypeList = res.data;
        }
      );
    },
    contractWordFn () {
      this.contractTypeVisible = true;
      this.defaultValueFn(); //设置默认值
    },
    //合同类型关键词提交
    contractTypeSubmit () {
      this.$refs.contractTypeForm.validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("targetStoreId", this.fileIdList.targetStoreId);
          formData.append("fileType", this.fileIdList.targetFileType);
          formData.append("templateId", this.contractTypeForm.region);
          //手动传标识参数
          if (this.hrefParam.aiCorpUserIdFlag) {
            formData.append(
              "aiCorpUserIdFlag",
              this.hrefParam.aiCorpUserIdFlag
            );
          }
          ApiCorpMethods.ContractOpreationController.contractExtractPost(
            formData
          ).then(res => {
            if (res.success) {
              this.contractTypeVisible = false;
              this.contractTypeForm = {};
              let routeUrl = this.$router.resolve({
                path: "/smartDoc/docExtract/extractList"
              });
              isInDingTalk ? location.href = routeUrl.href : window.open(routeUrl.href, "_blank");
            } else if (res.code === "10807") {
              this.frequencyInsufficient("抽取");
            } else {
              this.$message.error(res.description);
            }
          });
        }
      });
    },
    //风险审查弹窗===========
    riskExtractFn () {
      // this.$router.push('/smartDoc/docExamine/examine');
      this.riskExaminationVisible = true;
      this.defaultValueFn(); //设置默认值
    },
    //风险审查接口
    riskExtractSubmitFn () {
      this.$refs.riskForm.validate(valid => {
        if (valid) {
          //参数
          let obj = {
            ...this.riskForm
          };
          //手动传标识参数
          if (this.hrefParam.aiCorpUserIdFlag) {
            obj.aiCorpUserIdFlag = this.hrefParam.aiCorpUserIdFlag;
          }
          //参数补全
          obj.category = this.categoryList.find(item => {
            return item.id === obj.categoryId;
          }).name;
          let names = this.examinationRuleList.find(item => {
            return Object.values(item)[0] === obj.ruleId;
          });
          obj.rule = Object.keys(names)[0];
          let formData = new FormData();
          Object.keys(obj).forEach(key => {
            formData.append(key, obj[key]);
          });
          ApiCorpMethods.ContractOpreationController.contractRiskExamination(
            formData
          ).then(res => {
            if (res.success) {
              this.riskExaminationVisible = false;
              this.riskForm = {
                categoryId: "",
                ruleId: ""
              };
              this.examinationRuleList = [];
              let routeUrl = this.$router.resolve({
                path: "/smartDoc/docExamine/examineList"
              });
              isInDingTalk ? location.href = routeUrl.href : window.open(routeUrl.href, "_blank");
            } else if (res.code === "10807") {
              this.frequencyInsufficient("审核");
            } else {
              this.$message.error(res.description);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
/*  */
.upload_file_ul {
  display: flex;
  justify-content: space-around;
  .upload_file_li {
    width: 48%;
  }
}
.upload_sign {
  position: relative;
  display: block;
  box-sizing: content-box;
  border: 1px dashed #b4b4b4;
  text-align: center;
  color: #a1a1a1;
  overflow: hidden;
  cursor: pointer;
  margin: 10px 0;
  height: 230px;
  .file_type_img {
    width: 100px;
    height: 100px;
    margin: 30px 0 15px 0;
  }
  .input {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 230px;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
  .upload_icon_box {
    display: inline-block;
    padding: 15px 10px;
    margin: 30px 0 10px 0;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
    .icon_size {
      font-size: 45px;
      color: #409eff;
      margin: 0;
    }
  }
  .tip_color {
    font-size: 12px;
    padding: 4px 15px;
    color: #9a9a9a;
  }
}
/**/
.examination_ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .tool_list {
    width: 50%;
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;
    cursor: pointer;
    .img_size {
      max-width: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/signInfo/examination-tool.vue